import React from "react";
import { Button } from "../components/Button";
import Popover from "../components/Popover";

export default function LogInButton({
  redirect,
  label,
}: {
  redirect?: string;
  label?: string;
}) {
  return (
    <>
      <Button
        size="large"
        color="primary"
        onClick={() => {
          window.location.replace(
            `/login/${redirect ? `?redirect=${redirect}` : ""}`
          );
        }}
      >
        {label || "Log in"}
      </Button>
    </>
  );
}

export function LogInMenu({ redirect }: { redirect?: string }) {
  return (
    <>
      <Popover label="Log in">
        <p>
          If you’re a member of Makespace, you can log in to save this space to
          your recent spaces. You will briefly step out of this space until
          you’re logged in.
        </p>
        <LogInButton label="Log in with email" redirect={redirect} />
      </Popover>
    </>
  );
}
